import { render, staticRenderFns } from "./courseTwo.vue?vue&type=template&id=6006105e&scoped=true"
import script from "./courseTwo.vue?vue&type=script&lang=js"
export * from "./courseTwo.vue?vue&type=script&lang=js"
import style0 from "./courseTwo.vue?vue&type=style&index=0&id=6006105e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006105e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6006105e')) {
      api.createRecord('6006105e', component.options)
    } else {
      api.reload('6006105e', component.options)
    }
    module.hot.accept("./courseTwo.vue?vue&type=template&id=6006105e&scoped=true", function () {
      api.rerender('6006105e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/courseTwo.vue"
export default component.exports